export default "__VITE_ASSET__BxZq1hAR__"